/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import videojs from "video.js";
import OneStudioSSAIAdsPlugin from "../../onestudio-ssai-ads/src/onestudio-ads";
import play from "../../assets/images/icons/play-img-new.png";
import pause from "../../assets/images/icons/pause.png";
import fastforward from "../../assets/images/icons/fast-forward.png";
import rewind from "../../assets/images/icons/rewind.png";
import { setUserVideoProgress } from "../../utils/localCache.util";
import { getAllDeviceInfo } from "../../utils/deviceInfo.util";
import { getVastUrl } from "../../services/channelData.service";
import closeIcon from "../../assets/images/icons/close.png";
import "video.js/dist/video-js.css";
import { PLATFORMS } from "../../config/const.config";
import { ArrowLeftIcon, ListBulletIcon } from "@heroicons/react/16/solid";
import TrueXAdComponent from "./TrueXAdComponent";
import AdComponent from "./AdComponent";
import { loadExternalScript } from './loadScript';


const VideoJSPlayer = ({ id, videoData, resumeFrom, handlePlayerClose }) => {
    const videoPlayerContainer = useRef();
    const playerIns = useRef();

    const playerObj = {
        played: false,
        videoUrl: "",
        vastUrl: "",
    };

    const isLive = false;
    const appstoreUrl = process.env.REACT_APP_FIRETV_APPSTORE_URL;
    const appName = process.env.REACT_APP_FIRETV_APP_NAME;
    const appBundleId = process.env.REACT_APP_FIRETV_APP_BUNDLE;
    const appChannelName = process.env.REACT_APP_FIRETV_CHANNEL_NAME;
    const contentSeries = "";
    const deviceInfo = getAllDeviceInfo();
    const videoId = videoData.id;
    const { title, season, episode, rating, channelId, duration } = videoData;
    const genres = videoData.genres || "tvmovies";
    const liveStream = "";
    const producerName = "";
    const randomCB = Math.floor(Math.random() * 90000) + 10000;
    const [isPlaying, setIsPlaying] = useState(false);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth >= 426);
    const [showAdComponent, setShowAdComponent] = useState(false);
    const [userChoiceCard, setUserChoiceCard] = useState(false);
    const lastAdTimeRef = useRef(0);
    const [normalAdCompleted, setNormalAdCompleted] = useState(false);
    const [adCompleted, setAdCompleted] = useState(false);

    const timeFormat = (seconds) => {
        let secs = seconds;

        if (!secs && secs <= 0) {
            return "00:00:00";
        }

        let hours = null;
        if (secs / 3600 > 0) {
            hours = Math.floor(secs / 3600);
            secs -= hours * 3600;
        } else {
            hours = 0;
        }

        let mins = null;
        if (secs / 60 > 0) {
            mins = Math.floor(secs / 60);
            secs -= mins * 60;
        } else {
            mins = 0;
        }

        secs = Math.floor(secs);

        const hoursString = hours >= 10 ? String(hours) : `0${String(hours)}`;
        const minsString = mins >= 10 ? String(mins) : `0${String(mins)}`;
        const remainderString = secs >= 10 ? String(secs) : `0${String(secs)}`;

        return `${hoursString}:${minsString}:${remainderString}`;
    };

    const setupSSAI = async () => {
        try {
            await loadExternalScript(
                'https://b56i5gcrmh.execute-api.us-east-1.amazonaws.com/canvas-ad-insertion.js',
                'canvas-ssai-script'
            );
            console.log('✅ SSAI script requested..');

            const waitForSSAIReady = async (retries = 10, delay = 300) => {
                for (let i = 0; i < retries; i++) {
                    if (typeof window.canvasInitSSAIVideoPlayer === 'function') {
                        return true;
                    }
                    await new Promise(res => setTimeout(res, delay));
                }
                return false;
            };

            const ssaiReady = await waitForSSAIReady();

            if (!ssaiReady) {
                console.warn('⚠️ SSAI init function still not available after waiting.');
            } else {
                const playerElement = document.querySelector('video');
                if (playerElement) {
                    window.canvasInitSSAIVideoPlayer(
                        playerElement,
                        '9fce7d7b-85f9-40ad-ae28-839f19f883ff',
                        false
                    );
                    console.log('✅ canvasInitSSAIVideoPlayer initialized');
                } else {
                    console.warn('⚠️ Player element not found in DOM.');
                }
            }
        } catch (err) {
            console.error('❌ Failed to load SSAI script:', err);
        }
    };

    const setupPlayer = () => {
        try {
            playerIns.current = videojs(videoPlayerContainer.current, {
                controls: true,
                autoplay: true,
                fluid: true,
                controlBar: {
                    pictureInPictureToggle: false,
                },
                html5: {
                    vhs: {
                        experimentalBufferBasedABR: true,
                    },
                },
                poster: videoData.poster,
                sources: [
                    {
                        type: "application/x-mpegurl",
                        src: playerObj.videoUrl,
                    },
                ],
                tracks: [
                    {
                        src: videoData.vttUrl,
                        kind: "subtitles",
                        srclang: "en",
                        label: "English",
                    },
                ],
            });

            setupSSAI();
            playerIns.current.on("play", () => {
                if (resumeFrom > 0 && !playerObj.played) {
                    playerObj.played = true;
                    playerIns.current.currentTime(resumeFrom);
                }
            });

            playerIns.current.on("adstart", (ad) => {
                window.document.getElementById("player-bottom-bar").style.display =
                    "none";
            });
            playerIns.current.on("ads-ad-ended", () => {
                window.document.addEventListener(
                    "keydown",
                    (event) => {
                        if (window.document.getElementById("player-bottom-bar")) {
                            window.document.getElementById(
                                "player-bottom-bar"
                            ).style.display = "block";
                        }
                        setTimeout(() => {
                            if (window.document.getElementById("player-bottom-bar")) {
                                window.document.getElementById(
                                    "player-bottom-bar"
                                ).style.display = "none";
                            }
                        }, 7000);
                        // }
                    },
                    false
                );
            });

            document.querySelectorAll(".`player-overlay`").forEach((el) =>
                el.addEventListener("click", (event) => {
                    if (window.document.getElementsByClassName("vjs-control-bar")) {
                        window.document.getElementsByClassName(
                            "vjs-control-bar"
                        ).style.display = "block";
                    }
                    setTimeout(() => {
                        if (window.document.getElementsByClassName("vjs-control-bar")) {
                            window.document.getElementsByClassName(
                                "vjs-control-bar"
                            ).style.display = "none";
                        }
                    }, 10000);
                })
            );

            playerIns.current.on("timeupdate", () => {
                const watchTime = Number(Math.floor(playerIns.current.currentTime()));
                if (watchTime === 0) return;

                if (watchTime % 5 === 0) {
                    setUserVideoProgress(videoData.id, watchTime);
                }
            });

            playerIns.current.on("pause", () => {
                const watchTime = Math.floor(playerIns.current.currentTime());
                if (watchTime === 0) return;

                setUserVideoProgress(videoData.id, Number(watchTime));
            });
        } catch (e) {
            // ignore
        }
    };

    const clickOnBackButton = () => {
        const navbar = document.querySelector('.detailPage_navbar');
        const back_button = document.querySelector('.fullscreen-container-fixed .back-to-page');
        if (navbar) {
        navbar.style.display = '';
        back_button.style.top = '95px';
        }
        setTimeout(() => {
        document.querySelectorAll('.more-like-this').forEach(element => element.style.display = "block");
        document.querySelectorAll('.video-details').forEach(element => element.style.display = "block");
        handlePlayerClose();
        window.history.back();
        }, 100);
    };

    const updateProgressBar = (current, total) =>
        (Math.floor(current) / Math.floor(total)) * 100;

    useEffect(() => {
        let vastParams = process.env.REACT_APP_VAST_PARAMS;
        if (vastParams && vastParams.length) {
            vastParams = vastParams.replace("{content_type}", "");
            vastParams = vastParams.replace("{slot_type}", "");
            vastParams = vastParams.replace(
                "{device_ifa}",
                encodeURIComponent(deviceInfo.uid)
            );
            vastParams = vastParams.replace(
                "{ua}",
                encodeURIComponent(deviceInfo.ua)
            );
            vastParams = vastParams.replace(
                "{os}",
                encodeURIComponent(deviceInfo.os)
            );
            vastParams = vastParams.replace(
                "{osv}",
                encodeURIComponent(deviceInfo.osv)
            );
            vastParams = vastParams.replace(
                "{model}",
                encodeURIComponent(deviceInfo.model)
            );
            vastParams = vastParams.replace("{video_id}", videoId);
            vastParams = vastParams.replace(
                "{content_genre}",
                encodeURIComponent(genres)
            );
            vastParams = vastParams.replace(
                "{video_rating}",
                encodeURIComponent(rating)
            );
            vastParams = vastParams.replace("{content_duration}", duration);
            vastParams = vastParams.replace("{us_privacy}", "");
            vastParams = vastParams.replace(
                "{device_height}",
                deviceInfo.dimensions.height
            );
            vastParams = vastParams.replace(
                "{device_width}",
                deviceInfo.dimensions.width
            );
            vastParams = vastParams.replace(
                "{player_height}",
                deviceInfo.dimensions.height
            );
            vastParams = vastParams.replace(
                "{player_width}",
                deviceInfo.dimensions.width
            );
            vastParams = vastParams.replace("{dnt}", "");
            vastParams = vastParams.replace("{language}", "en");
            vastParams = vastParams.replace("{connection_type}", "");
            vastParams = vastParams.replace("{category}", "");
            vastParams = vastParams.replace("{cb}", randomCB);
            vastParams = vastParams.replace("{content_episode}", episode);
            vastParams = vastParams.replace(
                "{media_title}",
                encodeURIComponent(title)
            );
            vastParams = vastParams.replace(
                "{series_title}",
                encodeURIComponent(contentSeries)
            );
            vastParams = vastParams.replace("{content_season}", season);
            vastParams += "&app_bundle=B08JPDLL1Z";
            vastParams += `&app_name=${encodeURIComponent(appChannelName)}`;
            vastParams += `&app_store_url=${encodeURIComponent(appstoreUrl)}`;
        }

        playerObj.videoUrl = videoData.hlsUrl;
        playerObj.vastUrl = `${process.env.REACT_APP_VAST_BASE_URL}?${vastParams}`;
        setupPlayer();

        setTimeout(() => {
            // MediaMelon SmartSight setup
            try {
                let mmvjsPlugin = null;
                if (window.VideoJSMMSSIntgr) {
                    mmvjsPlugin = new window.VideoJSMMSSIntgr();
                } else {
                    // console.warn("MediaMelon plugin not found on window");
                }

                if (mmvjsPlugin && !mmvjsPlugin.getRegistrationStatus()) {
                    mmvjsPlugin.registerMMSmartStreaming(
                        "FireTVPlayer",
                        process.env.REACT_APP_MEDIAMELON_CUSTOMER_ID,
                        null,
                        window.location.hostname,
                        null,
                        null
                    );

                    mmvjsPlugin.reportPlayerInfo("FireTV", "ReactPlayer", "1.0.0");
                    mmvjsPlugin.reportAppInfo(appName || "Rayd8", "1.0.0");
                    mmvjsPlugin.setDeviceInfo(navigator.userAgent);
                    mmvjsPlugin.reportVideoQuality("HD");

                    const mmVideoAssetInfo = {
                        assetName: title,
                        assetId: videoId.toString(),
                        videoId: videoId.toString(),
                        contentType: "VOD",
                        genre: genres,
                        drmProtection: "Unknown",
                        episodeNumber: episode?.toString(),
                        season: season?.toString(),
                        seriesTitle: "",
                        videoType: isLive ? "LIVE" : "VOD",
                        customTags: {
                            channel: channelId?.toString() || ""
                        }
                    };

                    mmvjsPlugin.initialize(playerIns.current, playerObj.videoUrl, mmVideoAssetInfo, isLive);
                }
            } catch (error) {
                // console.error("MediaMelon SmartSight initialization failed", error);
            }

            // Total Duration
            const totalTimeDuration = window.document.getElementById("total-time");

            playerIns.current &&
                playerIns.current.on("loadedmetadata", () => {
                    const durations = timeFormat(
                        Math.floor(playerObj.videoPlayer.duration())
                    );
                    if (totalTimeDuration > 0) {
                        playerIns.current.currentTime(totalTimeDuration);
                    }
                    totalTimeDuration.innerText = durations;
                });

            const currentTimeDuration =
                window.document.getElementById("current-time");
            playerIns.current &&
                playerIns.current.on("timeupdate", () => {
                    const currentTime = Math.floor(playerIns.current.currentTime());
                
                    // Save progress every 5 seconds
                    if (currentTime > 0 && currentTime % 5 === 0) {
                        setUserVideoProgress(videoData.id, currentTime);
                    }
                
                    if (currentTime % 420 === 0 && lastAdTimeRef.current !== currentTime) {
                        lastAdTimeRef.current = currentTime;
                        playerIns.current && playerIns.current.pause();
                        setShowAdComponent(true);
                        setAdCompleted(false);
                        setNormalAdCompleted(false);
                    // } else {
                    //     setShowAdComponent(false);
                    //     setAdCompleted(false);
                    //     setNormalAdCompleted(true);
                    //     playerIns.current && playerIns.current.play();
                    }
                });

            playerIns.current &&
                playerIns.current.on("ended", () => {
                    setIsPlaying(false);
                    clickOnBackButton();
                });
        }, 1000);

        setTimeout(() => {
            if (window.document.getElementById("player-bottom-bar")) {
                window.document.getElementById("player-bottom-bar").style.display =
                    "none";
            }
        }, 10000);

        return () => {
            if (playerIns.current) {
                setTimeout(() => {
                    playerIns.current.dispose();
                }, 2000);
            }
        };
    }, []);

    useEffect(() => {
        if (adCompleted) {
            if (userChoiceCard === false) {
                setAdCompleted(true);
            } else {
                setAdCompleted(true);
                setShowAdComponent(false);
                playerIns.current && playerIns.current.play();
            }
        }
    }, [adCompleted]);

    useEffect(() => {
        const handleResize = () => {
          setIsMobileView(window.innerWidth >= 426);
        };
      
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Stop the video when the interactive or the normal ads shows
    useEffect(() => {
        if (showAdComponent) {
            playerIns.current && playerIns.current.pause();
        }
    }, [showAdComponent]);

    useEffect(() => {
        if (adCompleted && normalAdCompleted) {
            setShowAdComponent(false);
            playerIns.current?.play();
        }
    }, [adCompleted, normalAdCompleted]);

    const formattedDate = videoData.releaseDate ? timeAgo(videoData.releaseDate) : "N/A";
    function timeAgo(dateString) {
        const now = new Date();
        const past = new Date(dateString);
        const diffInMs = now - past;
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
        if (diffInDays < 1) return 'Today';
        if (diffInDays === 1) return '1 day ago';
        if (diffInDays < 30) return `${diffInDays} days ago`;
        const diffInMonths = Math.floor(diffInDays / 30);
        if (diffInMonths < 12) {
            return `${diffInMonths} month${diffInMonths !== 1 ? 's' : ''} ago`;
        }
        const diffInYears = Math.floor(diffInDays / 365);
        return `${diffInYears} year${diffInYears !== 1 ? 's' : ''} ago`;
    }

    const formattedTime = formatDuration(videoData.duration);
    function formatDuration(seconds) {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const formattedHours = hrs > 0 ? `${hrs.toString().padStart(2, '0')}h` : '';
        const formattedMinutes = mins > 0 ? `${mins.toString().padStart(2, '0')}m` : '';
        return `${formattedHours} ${formattedMinutes}`.trim();
    }

    return (
        <>
            <div className="custom_div_showing_ad" id="custom_div_showing_ad" name="custom_div_showing_ad"></div>
            {showAdComponent && (
                <>
                    {/* {!adCompleted ? (
                        <TrueXAdComponent
                            contentData={videoData}
                            onAdCompleted={() => setAdCompleted(true)}
                            selectChoiceCard={(value) => setUserChoiceCard(value)}
                        />
                    ) : (
                        <> */}
                            {!normalAdCompleted && userChoiceCard === false ? (
                                <AdComponent
                                    onNormalAdCompleted={() => {
                                        setNormalAdCompleted(true);
                                        setShowAdComponent(false); // hide ads completely
                                        playerIns.current?.play(); // resume video
                                    }}
                                />
                            ) : null}
                        {/* </>
                    )} */}
                </>
            )}

        <div className={`videojs-player-container video-flex-box ${showAdComponent ? 'ad-active' : ''}`}>
            <div
                className="close-video-container prj-element"
                id="back-to-page-video"
            >
                <ArrowLeftIcon className="size-2"
                    onClick={() => clickOnBackButton()} />
                {isMobileView ? videoData.title : (videoData.title.length > 20 ? `${videoData.title.slice(0, 20)}...` : videoData.title)}
            </div>
            <div id="video-player">
                <video
                    id={id}
                    className="video-js vjs-default-skin vjs-big-play-centered"
                    width="auto"
                    height="auto"
                    controls="true"
                    ref={videoPlayerContainer}
                />
            </div>
            <div className="player-overlay">
                <div className="player-bottom-bar" id="player-bottom-bar">
                    <div className="player-text">
                        <div className="player-watching-text">You&#39;re Watching</div>
                        <div className="player-title">{title}</div>
                    </div>
                    <div className="player-progress-track">
                        <div id="player-progress" className="player-progress-bar" />
                    </div>
                    <div className="player-timer">
                        <div id="current-time" className="player-time">
                            00:00:00
                        </div>
                        /
                        <div id="total-time" className="player-time">
                            00:00:00
                        </div>
                        <div className="player-button-group">
                            <div
                                className="rewind media-btn prj-element"
                                id="rewind"
                                data-focus-left="#rewind"
                                data-focus-right="#play-pause"
                                data-focus-up="#rewind"
                                data-focus-down="#rewind"
                                onClick={() => {
                                    videojs(`player`).currentTime(
                                        videojs(`player`).currentTime() - 10
                                    );
                                }}
                                role="none"
                            >
                                <img src={rewind} alt="" className="media-btn-img" />
                            </div>
                            <div
                                className="playpause media-btn prj-element"
                                id="play-pause"
                                data-focus-left="#rewind"
                                data-focus-right="#fast-forward"
                                data-focus-up="#play-pause"
                                data-focus-down="#play-pause"
                                role="none"
                            >
                                <img
                                    src={isPlaying ? pause : play}
                                    alt=""
                                    className="media-btn-img"
                                    onClick={() => {
                                        if (showAdComponent) return;
                                        if (videojs(`player`).paused()) {
                                            setIsPlaying(true);
                                            videojs(`player`).play();
                                        } else {
                                            setIsPlaying(false);
                                            videojs(`player`).pause();
                                        }
                                    }}
                                />
                            </div>
                            <div
                                className="fastforward media-btn prj-element"
                                id="fast-forward"
                                data-focus-left="#play-pause"
                                data-focus-right="#fast-forward"
                                data-focus-up="#fast-forward"
                                data-focus-down="#fast-forward"
                                onClick={() => {
                                    videojs(`player`).currentTime(
                                        videojs(`player`).currentTime() + 10
                                    );
                                }}
                                role="none"
                            >
                                <img src={fastforward} alt="" className="media-btn-img" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="video-info">
                <div className="info-head">
                    <ListBulletIcon className="icon" />
                </div>
                <div className="heading">
                    <span>Video Info</span>
                </div>
                <h4>{videoData.title}</h4>
                {formattedDate !== 'N/A' && (<span><b>Published:</b> {formattedDate}</span>)}
                {formattedTime !== '' && (<span><b>Duration:</b> {formattedTime}</span>)}
                <p>{videoData.description}</p>
            </div>
        </div>
        </>
    );
};

export default VideoJSPlayer;
